import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ONBOARDING_ROUTES } from 'src/app/shared/enums/appRoutes.enum';

export const tokenGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const token = route.queryParamMap.get('token');
  if (token) {
    return true;
  }
  router.navigate([ONBOARDING_ROUTES.MAGIC_LINK_EXPIRED]);
  return false;
};
